import { Link } from "react-router-dom";
import { hotRanking } from "@/mocks/posts";

export default function HotRanking({ limit = 5 }: { limit?: number }) {
  const items = hotRanking.slice(0, limit);

  return (
    <div className="bg-background-100 border border-background-200 rounded-lg p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-fire-line" aria-hidden="true"></i>
        </span>
        <h3 className="font-heading font-bold text-base text-foreground-950">本周热榜</h3>
      </div>
      <ol className="space-y-1">
        {items.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/post/${item.id}`}
              className="group flex items-start gap-3 py-2.5 border-b border-background-200 last:border-b-0 cursor-pointer"
            >
              <span
                className={`w-6 h-6 shrink-0 flex items-center justify-center rounded text-xs font-bold ${
                  index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                }`}
              >
                {index + 1}
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  热度 {item.heat}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}